const $ = require('jquery');
global.$ = global.jQuery = $;
window.jQuery = $;

require('slick-carousel');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

const ScrollHint = require('scroll-hint');
window.ScrollHint = ScrollHint;

import 'lightgallery.js';
import 'lg-thumbnail.js/dist/lg-thumbnail';
